module.exports = __webpack_public_path__ + "static/media/ic-landing-career.2ec0f98f.png";